module.exports = __webpack_public_path__ + "static/media/ToolHolder.da60f0af.jpg";